import { createAction, props } from '@ngrx/store';
import { SettingsFlow, UpdateSettingsFlowBody } from '@ory/client';

const REQUEST_CHANGE_PASSWORD = '[Profile][Request] Password change';
const RESPONSE_SUCCESS_CHANGE_PASSWORD = '[Profile][Response][Success] Password change';
const RESPONSE_FAIL_CHANGE_PASSWORD = '[Profile][Response][Fail] Password change';

export const RequestCreateSettingsFlow = createAction('[Auth][Settings][Request] create flow');
export const RequestGetSettingsFlow = createAction(
  '[Auth][Settings][Request] get flow',
  props<{ flowId: string }>()
);

export const SuccessCreateSettingsFlow = createAction(
  '[Auth][Settings][Success] create flow',
  props<{ flow: SettingsFlow }>()
);
export const FailCreateSettingsFlow = createAction(
  '[Auth][Settings][Fail] get flow',
  props<{ error: any }>()
);

export const RequestUpdateSettingsFlow = createAction(
  '[Auth][Settings][Request] updateflow',
  props<{ method: string; body: UpdateSettingsFlowBody }>()
);

export const SuccessUpdateSettingsFlow = createAction(
  '[Auth][Settings][Success] update flow',
  props<{ flow: SettingsFlow }>()
);
export const FailUpdateSettingsFlow = createAction(
  '[Auth][Settings][Fail] update flow',
  props<{ error: any; flow?: SettingsFlow }>()
);

export const BeginPasswordChange = createAction('BEGIN_PASSWORD_CHANGE');

export const RequestChangePasswordAction = createAction(
  REQUEST_CHANGE_PASSWORD,
  props<{ password: string }>()
);

export const ResponseSuccessChangePasswordAction = createAction(
  RESPONSE_SUCCESS_CHANGE_PASSWORD,
  props<any>()
);

export const ResponseFailChangePasswordAction = createAction(
  RESPONSE_FAIL_CHANGE_PASSWORD,
  props<{ error: any }>()
);
